import {CookieConsent} from './abstracts/cookie-consent';
CookieConsent.init();

import {initSliders} from '/vendor/skygate/kieser-patternlab/source/javascript/components/slider';
import Header from '/vendor/skygate/kieser-patternlab/source/javascript/components/header';
import FooterNavigation from '/vendor/skygate/kieser-patternlab/source/javascript/components/footer-navigation';
import Input from '/vendor/skygate/kieser-patternlab/source/javascript/components/input';
import Select from '/vendor/skygate/kieser-patternlab/source/javascript/components/select';
import Overlay from '/vendor/skygate/kieser-patternlab/source/javascript/components/overlay';
import HeroBanner from '/vendor/skygate/kieser-patternlab/source/javascript/components/hero-banner';
import ExpandableText from '/vendor/skygate/kieser-patternlab/source/javascript/components/expandable-text';
import ExpandableContent from '/vendor/skygate/kieser-patternlab/source/javascript/components/expandable-content';
import StudioNotificationBanner from '/vendor/skygate/kieser-patternlab/source/javascript/components/studio-notification';
import CollapseFilter from '/vendor/skygate/kieser-patternlab/source/javascript/components/collapse-filter';
import InfoBox from '/vendor/skygate/kieser-patternlab/source/javascript/components/info-box';
import Toggle from '/vendor/skygate/kieser-patternlab/source/javascript/components/toggle';
import StudioSearch from '/vendor/skygate/kieser-patternlab/source/javascript/components/studio-search';
import Textarea from '/vendor/skygate/kieser-patternlab/source/javascript/components/textarea';
import CardDescription from '/vendor/skygate/kieser-patternlab/source/javascript/components/card-description';
import Overlap2Col from '/vendor/skygate/kieser-patternlab/source/javascript/components/overlap-2col';
import {getStickyElHeights, setRootCssVar} from '/vendor/skygate/kieser-patternlab/source/javascript/helpers/helper';

import initForms from './components/forms/app';
initForms();

//-----------------------------------------------------
// Header
//-----------------------------------------------------
const headers = document.querySelectorAll('.header');
if (headers.length > 0) {
  headers.forEach((h) => {
    new Header(h);
  });
}

//-----------------------------------------------------
// Footer
//-----------------------------------------------------
const footers = document.querySelectorAll('.footer__navigation');
if (footers.length > 0) {
  footers.forEach((f) => {
    const footerNavigation = new FooterNavigation(f);
  });
}

//-----------------------------------------------------
// Search
//-----------------------------------------------------
const inputs = document.querySelectorAll('.form__input');
if (inputs.length > 0) {
  inputs.forEach((i) => {
    const input = new Input(i);
  });
}

//-----------------------------------------------------
// Select
//-----------------------------------------------------
const selects = document.querySelectorAll('.form__select');
if (selects.length > 0) {
  selects.forEach((s) => {
    const select = new Select(s);
  });
}

//-----------------------------------------------------
// Overlay
//-----------------------------------------------------
const overlays = document.querySelectorAll('.overlay');
if (overlays.length > 0) {
  overlays.forEach((o) => {
    const overlay = new Overlay(o);
  });
}

//-----------------------------------------------------
// Expandable Content
//-----------------------------------------------------
const expandableContents = document.querySelectorAll('.expandable-content');
if (expandableContents.length > 0) {
  expandableContents.forEach((ex) => {
    const expandableContent = new ExpandableContent(ex);
  });
}

//-----------------------------------------------------
// Expandable Text
//-----------------------------------------------------
const expandableTexts = document.querySelectorAll('.expandable-content[data-target-type="text"]');
if (expandableTexts.length > 0) {
  expandableTexts.forEach((ext) => {
    const expandableText = new ExpandableText(ext);
  });
}

initSliders();

//-----------------------------------------------------
// Hero Banner
//-----------------------------------------------------
const heroBanners = document.querySelectorAll('.hero-banner');
if (heroBanners.length > 0) {
  heroBanners.forEach((hb) => {
    const heroBanner = new HeroBanner(hb);
  });
}

//-----------------------------------------------------
// Studio Notification Banner
//-----------------------------------------------------
const studioNotificationBanners = document.querySelectorAll('.studio-notification');
if (studioNotificationBanners.length > 0) {
  studioNotificationBanners.forEach((snb) => {
    const studioNotificationBanner = new StudioNotificationBanner(snb);
  });
}

//-----------------------------------------------------
// Collapse Filter
//-----------------------------------------------------
const collapseFilters = document.querySelectorAll('.collapse-filter');
if (collapseFilters.length > 0) {
  collapseFilters.forEach((cf) => {
    const collapseFilter = new CollapseFilter(cf);
  });
}


// Info box
//-----------------------------------------------------
const infoBoxs = document.querySelectorAll('.info-box');
if (infoBoxs.length > 0) {
  infoBoxs.forEach((ib) => {
    const infoBox = new InfoBox(ib);
  });
}

//-----------------------------------------------------
// Toggle
//-----------------------------------------------------
const toggles = document.querySelectorAll('.form__toggle');
if (toggles.length > 0) {
  toggles.forEach((tg) => {
    const toggle = new Toggle(tg);
  });
}

//-----------------------------------------------------
// Studio Search
//-----------------------------------------------------
const studioSearches = document.querySelectorAll('.studio-search');
if (studioSearches.length > 0) {
  studioSearches.forEach((ss) => {
    const studioSearch = new StudioSearch(ss);
  });
}

//-----------------------------------------------------
// Textarea
//-----------------------------------------------------
const textAreas = document.querySelectorAll('.form__textarea');
if (textAreas.length > 0) {
  textAreas.forEach((ta) => {
    const textArea = new Textarea(ta);
  });
}

//-----------------------------------------------------
// Truncated card description
//-----------------------------------------------------
const truncatedCardDescriptions = document.querySelectorAll('.card__description--truncate-responsive');
if (truncatedCardDescriptions.length > 0) {
  truncatedCardDescriptions.forEach((cd) => {
    const truncatedCardDescription = new CardDescription(cd);
  });
}

//-----------------------------------------------------
// Truncated overlap content
//-----------------------------------------------------
const truncatedOverlapContents = document.querySelectorAll('.overlap-2col-float__base--expandable');
if (truncatedOverlapContents.length > 0) {
  truncatedOverlapContents.forEach((cd) => {
    const truncatedOverlapContent = new Overlap2Col(cd);
  });
}

//-----------------------------------------------------
// Added scroll margin top value to .section
//-----------------------------------------------------
const totalHeight = getStickyElHeights([
  '.header',
  '.promotion-banner',
  '.studio-notification'
]);

setRootCssVar('--sticky-el-height', totalHeight);

//-----------------------------------------------------
// Country Select
//-----------------------------------------------------
const countrySelects = document.getElementsByClassName('country-select');
if(countrySelects.length) {
  import('./components/country-select').then(module => {
    module.default(countrySelects);
  })
}

//-----------------------------------------------------
// Job Filter
//-----------------------------------------------------
const jobs = document.querySelectorAll('[data-job-offer="true"]');
if(jobs.length) {
  import('./components/job-filter').then(module => {
    module.default(jobs);
  })
}

//-----------------------------------------------------
// Price
//-----------------------------------------------------
const price = document.querySelectorAll('.card__price');
if(price.length) {
  import('./components/price-detail').then(module => {
    module.default();
  })
}